import React, { useState, useEffect, createContext } from "react"

// Data
import data from "./data/templateData.json"

// State Context
export const StateContext = createContext()

export const StateProvider = props => {
  const [state, setState] = useState(data.pages)

  useEffect(() => {
    const localData = localStorage.getItem("stateList")
    if (localData) {
      setState(JSON.parse(localData))
    }
  }, [])

  useEffect(() => {
    localStorage.setItem("stateList", JSON.stringify(state))
  })

  return (
    <StateContext.Provider value={[state, setState]}>
      {props.children}
    </StateContext.Provider>
  )
}

// Shopping Context
export const ShoppingContext = createContext()

export const ShoppingProvider = props => {
  const [shopping, setShopping] = useState({
    adress: "",
    chosenAttractions: [],
    totalDays: 0,
    price: 0,
    name: "",
    email: "",
    emailConfirm: "",
    phone: "",
    anlass: "",
    startDate: new Date(),
    endDate: "",
    message: "",
  })

  return (
    <ShoppingContext.Provider value={[shopping, setShopping]}>
      {props.children}
    </ShoppingContext.Provider>
  )
}

// Modal Context
export const ModalContext = createContext()

export const ModalProvider = props => {
  const [modal, setModal] = useState(true)

  useEffect(() => {
    const localModal = localStorage.getItem("modal")
    if (localModal) {
      setModal(JSON.parse(localModal))
    }
  }, [])

  useEffect(() => {
    localStorage.setItem("modal", JSON.stringify(modal))
  })

  return (
    <ModalContext.Provider value={[modal, setModal]}>
      {props.children}
    </ModalContext.Provider>
  )
}
